import { createSlice } from "@reduxjs/toolkit";
import {
  callBackend,
  downloadCSV,
  fetchNext,
  prepareSearchParams,
  search,
} from "./utils";
import { fields, sources } from "../utils";
import { config } from "../config";

const EXPORT_ALL_API_URL = `${config.API_URL}/download/all`;

export const searchSlice = createSlice({
  name: "tableExtractor",
  initialState: {
    searchResults: {},
    collapseResults: false,
    loadingResults: false,
    searchInitiated: false,
    searchTerm: "",
    searchFields: fields.map((f) => f.value),
    sources: sources.map((s) => s.value),
    date_from: "",
    date_to: "",
  },
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload.searchTerm;
    },
    setSearchFields: (state, action) => {
      state.searchFields = action.payload.searchFields;
    },
    setSources: (state, action) => {
      state.sources = action.payload.sources;
    },
    setDateFrom: (state, action) => {
      state.date_from = action.payload.date_from;
    },
    setDateTo: (state, action) => {
      state.date_to = action.payload.date_to;
    },
    setcollapseResults: (state, action) => {
      state.collapseResults = action.payload.collapseResults;
    },
    exportAllSearchResults: (state) => {
      callBackend(
        EXPORT_ALL_API_URL,
        prepareSearchParams(
          state.searchTerm,
          1,
          state.searchFields,
          state.date_from,
          state.date_to,
          state.sources,
          state.collapseResults
        ),
        "blob"
      ).then((res) => {
        downloadCSV(res);
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(search.fulfilled, (state, action) => {
      state.searchResults = action.payload;
      state.loadingResults = false;
    });
    builder.addCase(search.pending, (state, action) => {
      state.searchResults = {};
      state.loadingResults = true;
      state.searchInitiated = true;
    });
    builder.addCase(fetchNext.fulfilled, (state, action) => {
      state.searchResults.data = [
        ...state.searchResults.data,
        ...action.payload.data,
      ];
      state.searchResults.next_page = action.payload.next_page;
      state.searchResults.num_docs += action.payload.num_docs;
      state.loadingResults = false;
    });
    builder.addCase(fetchNext.pending, (state, action) => {
      state.loadingResults = true;
    });
  },
});

const {
  setSearchTerm,
  setSearchFields,
  setSources,
  setDateFrom,
  setDateTo,
  setcollapseResults,
  exportAllSearchResults,
} = searchSlice.actions;
export {
  search,
  fetchNext,
  setSearchTerm,
  setSearchFields,
  setSources,
  setDateFrom,
  setDateTo,
  setcollapseResults,
  exportAllSearchResults,
};
export const searchReducer = searchSlice.reducer;
